import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Stack } from "@curves/ui-base";

function OverviewListActionBar({ className, alignItems = 'center', justifyContent = 'end', children, ...rest }) {
    return (
        <Stack className={clsx('overview-list__action-bar', className)} alignItems={alignItems} justifyContent={justifyContent} {...rest}>
            {children}
        </Stack>
    );
}

OverviewListActionBar.propTypes = {
    className: PropTypes.string,
    alignItems: PropTypes.string,
    justifyContent: PropTypes.string,
    children: PropTypes.node,
    batchActionsProps: PropTypes.object,
    singleActionsProps: PropTypes.object,
};

export default OverviewListActionBar;
